import {axiosAPI} from "./axiosClient"
import { UserService } from './UserService';

import qs from "qs";
import { getParams } from '../helper/Helper'

export const ProformaService = {

  getProformas(folderId, params) {
    return axiosAPI.get(`/${folderId}/proformas?lookup=true&${getParams(params)}`)
  },

  getProformasSummary(folderId, params) {
    return axiosAPI.get(`/${folderId}/proformas/summary?lookup=true&${getParams(params)}`)
  },

  getProformasPDF(folderId, params) {
    return axiosAPI.get(`/${folderId}/proformas?lookup=true&${getParams(params)}&format=pdf`, {responseType: 'blob'})
  },

  getProforma(folderId, proformaId){
    return axiosAPI.get(`/${folderId}/proformas/${proformaId}?lookup=true`)
  },

  updateProforma(folderId, proformaId){
    return axiosAPI.put(`/${folderId}/proformas/${proformaId}`)
  },

  duplicateProforma(folderId, proformaId){
    return axiosAPI.post(`/${folderId}/proformas/${proformaId}/dupliquer`)
  },

  generateFacture(folderId, proformaId, dataPost){
    return axiosAPI.post(`/${folderId}/proformas/${proformaId}/generate`, qs.stringify(dataPost))
  },

  convertToFacture(folderId, proformaId){
    return axiosAPI.post(`/${folderId}/proformas/${proformaId}/convert/facture`)
  },

  convertToAbonnement(folderId, proformaId){
    return axiosAPI.post(`/${folderId}/proformas/${proformaId}/convert/abonnement`)
  },

  postProforma(folderId, dataPost){
    return axiosAPI.post(`/${folderId}/proformas`, qs.stringify(dataPost))
  },
  
  removeProformas(folderId, proformaIdList) {
    var params = '?proformas[]=' + proformaIdList.join('&proformas[]=');
    return axiosAPI.delete(`/${folderId}/proformas${params}`)
  },

  
}